<template>
  <div v-if="!isFooterOnly">
    <form @submit.prevent="handleSubmit">
      <div class="field">
        <label class="label">Due Date</label>
        <div class="control">
          <input
            type="datetime-local"
            class="input"
            v-model="editDateLocal"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Amount</label>
        <div class="control">
          <input
            type="number"
            step="0.01"
            class="input"
            v-model.number="form.amount"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Currency</label>
        <div class="control">
          <div class="select">
            <select v-model="form.currency">
              <option value="USD">USD</option>
              <option value="TL">TL</option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Is Paid</label>
        <div class="control">
          <div class="select">
            <select v-model="form.is_paid">
              <option value="true">Paid</option>
              <option value="false">Not Paid</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div v-else class="buttons">
    <button class="button" @click="closeModal">Cancel</button>
    <button class="button is-primary" @click="triggerSubmit">
      Update Invoice
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { httpInstance as http } from "@/plugins/http";
import toast from "@/utils/toast";

export default {
  name: "ModalEditInvoice",
  props: {
    modalData: {
      type: Object,
      default: () => ({}),
    },
    modalIndex: {
      type: Number,
      required: true,
    },
    isFooterOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        id: null,
        due_date: "",
        amount: null,
        currency: "",
        is_paid: "",
        contract_id: null,
      },
    };
  },
  computed: {
    editDateLocal: {
      get() {
        return this.formatToLocal(this.form.due_date);
      },
      set(value) {
        this.form.due_date = this.formatToBackend(value);
      },
    },
  },
  methods: {
    ...mapActions(["closeTopModal"]),
    closeModal() {
      this.closeTopModal();
    },
    triggerSubmit() {
      this.$root.$emit("edit-invoice-submit");
    },
    formatToLocal(backendDate) {
      if (!backendDate) return "";
      return backendDate.slice(0, -4);
    },
    formatToBackend(localDate) {
      if (!localDate) return "";
      return localDate + ":00Z";
    },
    async handleSubmit() {
      try {
        const formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("due_date", this.form.due_date);
        formData.append("amount", this.form.amount);
        formData.append("currency", this.form.currency);
        formData.append("is_paid", this.form.is_paid);
        formData.append("contract_id", this.form.contract_id);

        const response = await http.patch("invoices/", formData);

        if (response.status === 200) {
          toast.success("Invoice updated successfully");
          this.closeModal();
          this.$root.$emit("invoice-updated");
        }
      } catch (error) {
        console.error("Error updating invoice:", error);
        toast.error("Error occurred");
      }
    },
    initializeForm() {
      if (this.modalData) {
        this.form.id = this.modalData.id;
        this.form.due_date = this.modalData.due_date || "";
        this.form.amount = this.modalData.amount || null;
        this.form.currency = this.modalData.currency || "";
        this.form.is_paid = this.modalData.is_paid || "";
        this.form.contract_id = this.modalData.contract_id || null;
      }
    },
  },
  watch: {
    modalData: {
      handler() {
        this.initializeForm();
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeForm();

    if (!this.isFooterOnly) {
      this.$root.$on("edit-invoice-submit", this.handleSubmit);
    }
  },
  beforeDestroy() {
    if (!this.isFooterOnly) {
      this.$root.$off("edit-invoice-submit", this.handleSubmit);
    }
  },
};
</script>

<style scoped>
.buttons {
  justify-content: flex-end;
}
</style>
